@import "../../global/components/splash-and-welcome-page";
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  --wrapper-copacity: 0;
  --wrapper-min-inline-size: 700px;
  --wrapper-max-inline-size: 1040px;
  --wrapper-block-size: 640px;
  transition: var(--timing-regular) opacity;

  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 100%;
  block-size: 100%;
  padding: var(--spacing-padding-xl);

  overflow: auto;
}

.wrapper {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr var(--wrapper-block-size);
  block-size: var(--wrapper-block-size);
  // min-inline-size: var(--wrapper-min-inline-size);
  max-inline-size: var(--wrapper-max-inline-size);

  background-color: var(--color-accent-surface-elevation-1);
  border-radius: 12px;

  overflow: auto;
  transform: translateY(4px);
}

// Side inline-start (the illustration)
.side-inline-start {
  background-size: cover;
}

// Side inline-end (the content)
.side-inline-end {
  position: relative;
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  padding-block: 64px;
  padding-inline: 80px;

  transition: var(--timing-slow) grid-template-rows;
  overflow: auto;
}

.close-button {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
}

// header
.header {
  display: grid;
  gap: var(--spacing-gap-xl);
  margin-block-end: 92px; // Specific layout spacing - no exact token available
}
.header__logo__close-button {
  display: flex;
  justify-content: space-between;
}
.title {
  color: var(--color-text-neutral-strawberry);
  letter-spacing: 0.02em;
}
.next-version {
  color: var(--color-text-neutral-strawberry);
}
.header__description {
  color: var(--color-text-neutral-disabled);
  line-height: 1.45 !important;
  // TODO: Discuss with Design Team about line-height.
  // Mercury line-heights looks tight to me.
}

.main {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-l);
  // margin-block-start: auto;

  overflow: auto;
}
.log__container {
  --logVisibleLines: 7;
  --logFontSize: var(
    --font-size-body-s
  ); // 12px is the font size of .caption-regular-l
  --logLineHeight: var(
    --line-height-relaxed
  ); // 1.2 is the line-height of .caption-regular-l
  --logGap: 4px;
  --logContainerBlockSize: calc(
    var(--logFontSize) * var(--logLineHeight) * var(--logVisibleLines) +
      calc(var(--logGap) * (var(--logVisibleLines) - 1))
  );
  block-size: var(--logContainerBlockSize);
  // TODO: Add/include on Mercury a monospaced font, and then use it here.
  font-family: var(--font-family-code);
  color: var(--color-text-neutral-disabled);
  display: flex;
  flex-direction: column-reverse;
  gap: var(--logGap);
  overflow: hidden;
  // margin-block-start: auto;

  &:hover {
    overflow: auto;
  }

  > p {
    // WA: This overrides the font family of the typographic style applied on the p tag
    font-family: inherit;
  }
}
.log__message {
  opacity: 0;
  transition: var(--timing-regular) opacity;
  animation: fadeInLogMessage 0.45s ease-out forwards;

  &--error {
    color: var(--color-text-error-default);
  }
}

// footer
.footer {
  display: grid;
  grid-auto-rows: max-content;
  gap: var(--spacing-gap-l);
  margin-block-start: 24px;
}
.error-message {
  color: var(--color-text-error-default);
  margin-block-start: auto;
  // TODO: Use clamp from a helper mixin
  display: -webkit-box;
  -webkit-line-clamp: 2;
}

// helpers
.status--processing {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: var(--spacing-gap-xs);
}

@keyframes fadeInLogMessage {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
